//  Configure the crawler state ， Requests that do not need to be initiated 
const map = {};
export default function ({ url = '', method = 'get' }) {
    url = url.split('?')[0];
    let m = map[url];
    if (m === 'all') {
        return true;
    }
    if (m === method) {
        return true;
    }
    return false;
}
